import { IsBoolean, IsString } from 'class-validator';
import { EntityVm } from 'api/core/entity.vm';

export enum OrdersStatus {
  PENDING = 'PENDING',
  CLOSED = 'CLOSED',
}

export class OrderVm extends EntityVm {
  @IsString()
  circuitId: string;

  @IsString()
  circuitName: string;

  @IsString()
  clientId: string;

  @IsString()
  clientName: string;

  @IsBoolean()
  status: OrdersStatus;
}
